// Leitura do vCard que vem no corpo da mensagem de contato.
//
// O que chega é o texto inteiro do cartão, e o WhatsApp escreve com prefixo de
// grupo e parâmetros na propriedade — nada de `TEL:+55...` limpo:
//
//   BEGIN:VCARD
//   VERSION:3.0
//   N:germanio;Flavio;;;
//   FN:Flavio germanio
//   item1.TEL;waid=556196080740:+55 61 9608-0740
//   item1.X-ABLabel:Celular
//   X-WA-LID:7232859144347
//   END:VCARD
//
// Um cartão pode trazer vários telefones, e uma mensagem pode trazer vários
// cartões emendados (BEGIN…END repetidos), que é o que o WhatsApp manda quando
// se encaminha mais de um contato de uma vez.

// Separa "item1.TEL;waid=556196080740" e "+55 61 9608-0740" — o primeiro ":"
// é o que divide propriedade de valor; os demais fazem parte do valor.
const partirLinha = (linha) => {
	const corte = linha.indexOf(":");
	if (corte === -1) return null;

	const propriedade = linha.slice(0, corte);
	const valor = linha.slice(corte + 1).trim();
	// "item1.TEL;waid=..." → "TEL"
	const nome = propriedade.split(";")[0].split(".").pop().toUpperCase();

	return { nome, propriedade, valor };
};

// O `waid` é o número no formato que o WhatsApp usa (só dígitos, com DDI). É
// mais confiável que o valor visível, que vem formatado para leitura humana
// ("+55 61 9608-0740") e às vezes sem DDI.
const numeroDaLinha = ({ propriedade, valor }) => {
	const waid = /waid=(\d+)/i.exec(propriedade);
	if (waid) return waid[1];

	return valor.replace(/\D/g, "");
};

export const lerVcards = (corpo) => {
	const linhas = String(corpo || "").split(/\r?\n/);

	const cartoes = [];
	let atual = null;

	linhas.forEach((bruta) => {
		const linha = bruta.trim();
		if (!linha) return;

		if (/^BEGIN:VCARD$/i.test(linha)) {
			atual = { nome: "", numeros: [] };
			return;
		}

		if (/^END:VCARD$/i.test(linha)) {
			if (atual && (atual.nome || atual.numeros.length)) cartoes.push(atual);
			atual = null;
			return;
		}

		if (!atual) return;

		const campo = partirLinha(linha);
		if (!campo) return;

		// FN é o nome de exibição. N é o nome estruturado
		// ("sobrenome;nome;;;") e serve de reserva quando não há FN.
		if (campo.nome === "FN" && campo.valor) {
			atual.nome = campo.valor;
		} else if (campo.nome === "N" && !atual.nome) {
			atual.nome = campo.valor
				.split(";")
				.filter(Boolean)
				.reverse()
				.join(" ")
				.trim();
		} else if (campo.nome === "TEL") {
			const numero = numeroDaLinha(campo);
			if (numero) atual.numeros.push(numero);
		}
	});

	return cartoes;
};

export default lerVcards;
